import React, { useState , useEffect} from 'react'; 
import { Link } from 'react-router-dom';
import { getPrincipalMessage } from "../Service/Api";  
const Testimonials = () => {

  const [selectedTestimonial, setSelectedTestimonial] = useState(0);
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const messages = await getPrincipalMessage();
      const filterData = messages.filter((item) => item.category === "Principal") 
      setData(filterData);
    };
    fetchData();
  }, []);
 

  const testimonials = [ 
    {
      name: data[0]?.name || 'Principal Name',
      designation: data[0]?.category || 'Principal',
      message: 'Principal Message',
      testimonial:  data[0]?.message || `At Carmel Convent School, we aim to provide students with experiential learning that incorporates essential life skills and values, and encourages them to enjoy what they do. We believe in fostering a genuine love for learning, ensuring that the knowledge our students acquire stays with them for life. Carmelites are privileged to inherit a rich heritage. In this rapidly evolving era of change, we strive to strengthen the old while embracing the new.In today’s competitive world, Carmel Convent School empowers the students intellectually, emotionally, and spiritually, nurturing their confidence to face life's challenges with resilience and grace. Our curriculum is designed not just to educate but to inspire, encouraging students to think critically, act ethically, and lead with compassion.I am delighted to lead a school with a rich past and a promising future. Our school community is a vibrant tapestry of students, parents, and educators working in harmony. Together we form a formidable team, ensuring that the Carmel banner flies higher each year.`,
      image:data[0]?.attachments ? `https://webapi.entab.info/api/image/${data[0].attachments}` : 'https://webapi.entab.info/api/image/CCSDH/public/Images/principal.png',
      link: '/'
    }
     
  ]; 

    const handleTestimonialClick = (index) => {
        setSelectedTestimonial(selectedTestimonial === index ? 0 : index);
    };

    return (
      
        <div className="row message-container"> 
        <div className=" col-lg-4 messageimg"> 
            {testimonials.map((testimonial, index) => (
                <div key={index} className="testimonial">
                    <img
                        src={testimonial.image}
                        alt={testimonial.name}
                        onClick={() => handleTestimonialClick(index)}
                        className={selectedTestimonial === index ? 'active img-fluid' : ''}
                    />
                </div>
            ))}
           
        </div>
             <div className=" col-lg-8 messagebox">
              <div className='title'>
              <p>Message section <img src='https://webapi.entab.info/api/image/CCSDH/public/Images/msg.gif' className='img-fluid' /></p>
                <h2>Principal’s Message</h2>
              </div>
                 <div className={`${selectedTestimonial !== 0 ? 'slide-in' : 'slide-out'}`}> 
                       <div className="messagedesc">
                       <p><div dangerouslySetInnerHTML={{ __html: testimonials[selectedTestimonial].testimonial }} /> </p>
                       </div> 
                        <div className="messageboximg">
                           <p>{testimonials[selectedTestimonial].name}  </p>
                        </div>
                          <button className='read-more'><Link to="/PrincipalMessage">Read More <i class="bi bi-chevron-right"></i></Link></button>
                        </div>
                    </div> 
            </div>  
    );
};

export default Testimonials;
